const crud = { c: false, r: false, u: false, d: false };

export const users = Object.freeze({
  user: { ...crud },
  role: { ...crud },
  roleCount: { ...crud },
});
